$(document).ready(function() {
  $("#nav a").click(function() {
    if (
      $(this).hasClass("router-link-exact-active") ||
      $(this).hasClass("router-link-active")
    ) {
      $("#nav").hide();
    }
  });
});

if (!Date.prototype.toLocalISOString) {
  // Anonymous self-invoking function
  (function () {

  function pad(number) {
    if (number < 10) {
      return '0' + number;
    }
    return number;
  }

  Date.prototype.toLocalISOString = function () {
    var timestamp = this.getFullYear() +
    '-' + pad(this.getMonth() + 1) +
    '-' + pad(this.getDate()) +
    'T' + pad(this.getHours()) +
    ':' + pad(this.getMinutes()) +
    ':' + pad(this.getSeconds());
    if (this.getTimezoneOffset() == 0) { timestamp = timestamp + "Z" }
    else {
    if (this.getTimezoneOffset() < 0) { timestamp = timestamp + "+" }
    else { timestamp = timestamp + "-" }
    timestamp = timestamp + pad(Math.abs(this.getTimezoneOffset() / 60).toFixed(0));
    timestamp = timestamp + ":" + pad(Math.abs(this.getTimezoneOffset() % 60).toFixed(0));
    }
    return timestamp;
    };

  }());
}